var exports = {
  "lJ": "AttachmentMosaic.module__mosaicContainerWrapper___WXlBbz",
  "Yt": "AttachmentMosaic.module__mosaicContainer___WXlBbz",
};

module.exports = exports;
